import {FormatAddressProps} from 'presentation/constants';
import {formatAddress} from './formatAddress';
import {getCityAndUfByRegex} from './getCityAndUfByRegex';

export type AddressData = {
	formattedAddress: string;
	addressForMaps?: string;
};

export function getAddressforMaps(addressData: FormatAddressProps | string): AddressData {
	if (!addressData) {
		return {formattedAddress: '', addressForMaps: ''};
	}

	if (typeof addressData === 'string') {
		const splittedAddress = addressData.split(' - ');
		const {city, uf} = getCityAndUfByRegex(addressData);

		const addressForMaps = `${splittedAddress[0]} - ${city}/${uf}`;

		return {formattedAddress: addressData, addressForMaps};
	}

	const {complement, reference} = addressData;
	const formattedAddress = formatAddress({
		...addressData,
		complement,
		reference,
	});
	const addressForMaps = formatAddress({
		...addressData,
		complement: '',
		reference: '',
	});

	return {formattedAddress, addressForMaps};
}
